<template>
    <div class="like-container">
        <h2 class="page-title">我的喜欢</h2>

        <!-- 喜欢列表 -->
        <div class="like-list">
            <div class="like-item" v-for="item in likes" :key="item.id">
                <h3>{{ item.title }}</h3>
                <p>{{ item.summary }}</p>
                <div class="like-meta">
                    <span>点赞时间：{{ item.likeTime }}</span>
                    <button @click="unlike(item.id)" class="btn-unlike">
                        <i class="bi bi-heartbreak"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- 空状态提示 -->
        <div v-if="likes.length === 0" class="empty-state">
            <i class="bi bi-heart-fill fs-1 text-muted"></i>
            <p>暂无喜欢的内容</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyLike',
    data() {
        return {
            // 模拟喜欢数据
            likes: [
                {
                    id: 1,
                    title: 'React Hooks 最佳实践',
                    summary: 'useState、useEffect、useContext 的使用技巧...',
                    likeTime: '2024-01-14'
                }
            ]
        }
    },
    methods: {
        /**
         * 取消喜欢
         * @param {number} id - 喜欢项ID
         */
        unlike(id) {
            this.likes = this.likes.filter(item => item.id !== id)
            // 这里可以添加 API 调用
            console.log('取消喜欢：', id)
        }
    }
}
</script>

<style scoped>
.page-title {
    color: #2c3e50;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
}

.like-item {
    background: white;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.like-item h3 {
    color: #2c3e50;
    font-size: 18px;
    margin-bottom: 8px;
}

.like-item p {
    color: #7f8c8d;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 10px;
}

.like-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #95a5a6;
}

.btn-unlike {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    padding: 5px;
    border-radius: 3px;
}

.btn-unlike:hover {
    background-color: #ffe6e6;
}

.empty-state {
    text-align: center;
    padding: 40px;
    color: #95a5a6;
}

.empty-state i {
    margin-bottom: 15px;
}
</style>